import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/codesoil.jpg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Neighborhood2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("#"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            Social<span className="purple"> Action</span> in the Neighborhood
            </h1>
            <p className="home-about-body">
            We’re excited to introduce <b className="purple">Code & Soil</b>,
            a unique program that bridges the wonders of nature with the power of technology, engaging children, youth, and adults alike.
            This innovative <b className="purple">Neighborhood Program</b> fosters <b className="purple">collaboration</b> through <b className="purple">social action</b>, with efforts aimed at improving the well-being
            of individuals in neighborhoods, regardless of their beliefs or background. Motivated by the desire to serve humanity and drive
            positive social change, the program blends hands-on organic gardening with the fundamentals of coding, offering participants a
            dynamic and enriching learning experience.
            <br />
            <br />As they explore how technology can enhance gardening such as creating automated watering systems or using coding to track
            plant growth—young people gain valuable skills in both fields. By learning to code while nurturing a garden, participants develop
            problem-solving skills, creativity, and teamwork, while also gaining a deeper understanding of environmental stewardship and
            connecting meaningfully with the earth.
            <br />
            <br/>
            Additionally, participants learn <b className="purple">entrepreneurship</b> by selling the plants they grow,
            designing simple websites or online shops, and gaining basic skills in <b className="purple">accounting</b>, <b className="purple">budgeting</b>, and <b className="purple">marketing</b>. They also develop
            confidence in presenting their products. If selling isn’t an option, participants can donate their plants to local charities
            or neighbors, experiencing the joy of giving back to their community. The program also fosters  <b className="purple">community involvement</b> by inviting
            local residents to purchase plants, volunteer, or mentor participants. To showcase their work, a seasonal event, such as a
            garden-tech expo, is organized in the community where participants display their plants and tech creations, offering them a
            platform to sell or share their efforts.

            <br />
            <br />
            The Code & Soil program empowers young people to see how technology can be applied to <b className="purple">solve real-world problems</b>, fostering a generation
            of innovators who are as comfortable working with nature as they are with technology. Through this initiative, we aim to inspire
            a new wave of <b className="purple">digital and environmental problem-solvers</b>, equipping them with the skills to navigate and shape both the natural
            and digital worlds of tomorrow.
            <br />
            <br />

          </p>
          <Button onClick={handleClick}>Volunteer</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
      
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Neighborhood2;
